import { useEffect } from 'react';

// https://usehooks.com/useOnClickOutside/
function useOnClickOutside(ref, handler, root) {
  const _root = root || document;

  useEffect(
    () => {
      const listener = event => {
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      _root.addEventListener('mousedown', listener);
      _root.addEventListener('touchstart', listener);
      return () => {
        _root.removeEventListener('mousedown', listener);
        _root.removeEventListener('touchstart', listener);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler, _root],
  );
}

export default useOnClickOutside;
